import { Record, List, Map } from 'immutable'

export const ConfirmedGroup = new Record({
  numAccepts: 0,
  numRejects: 0,
  isConfirmed: false,
  creatorEmail: null,
  groupLotteryNumber: null,
  leaderEmail: null,
  memberIds: new List(),
  preferences: new List(),
  key: null,
  groupSize: null,
  memberRecords: new Map(),
  isDisbanded: null,
  hasSubmittedPreferences: false,
  multiYearGroup: false
})


// WEBPACK FOOTER //
// ./src/core/confirmed-group/confirmed-group.js